import React from 'react'
import styled from 'styled-components'
import {menuData} from '../data/MenuData'
import {Button} from './Button'
import {Link} from 'react-router-dom'
import {FaTimes} from 'react-icons/fa'

    const DropdownContainer = styled.div`
        position: fixed;
        z-index:999;
        width: 100%;
        height: 100%;
        background: #cd853f;
        display:grid;
        align-items: center;
        top: ${({isOpen})=> (isOpen ? '0' : '-100%')};
        left: 0;
        transition: .3s ease-in-out;
        opacity: ${({isOpen})=> (isOpen ? '1' : '0')};
    `
    const Icon = styled.div`
        position:absolute;
        top: 0rem;
        right: 1rem;
        cursor: pointer;
        background: trasparent;
        font-size: 2rem;
        outline: none;
    `
    const CloseIcon = styled(FaTimes)`
        color: #000d1a;
        font-size: 3rem;
    `
    const DropdownWrapper = styled.div`
        
    `
    const DropdownMenu = styled.div`
        display:grid;
        grid-template-columns: 1fr;
        grid-template-rows: repeat(4, 80px);
        text-align: center;
        margin-bottom: 4rem;

        @media screen and (max-width: 480px) {
            grid-template-rows: repeat(4, 60px);
        }
    `
    const DropdownLink = styled(Link)`
        display:flex;
        align-items:center;
        justify-content:center;
        color: #fff;
        font-size: 1.5rem;
        text-decoration:none;
        cursor:pointer;
        transition: .2s ease-in-out;

        &:hover{
            color:#000d1a;
        }
    `
    const BtnWrap = styled.div`
        display:flex;
        justify-content:center;
    `
    const Dropdown = ({isOpen, toggle}) => {
        return (
            <DropdownContainer isOpen={isOpen} onClick={toggle}>
                <Icon onClick={toggle}>
                    <CloseIcon />
                </Icon>
                <DropdownWrapper>
                    <DropdownMenu>
                        {menuData.map((item, index) => (
                            <DropdownLink to={item.link} key={index}>
                                {item.title}
                            </DropdownLink>
                        ))}
                    </DropdownMenu>
                    <BtnWrap>
                        <Button primary='true' round='true' big='true' to='/contact'>
                            Nous contacter
                        </Button>
                    </BtnWrap>
                </DropdownWrapper>
            </DropdownContainer>
        );
    }

export default Dropdown;
